const ngsProducts = [
  'LuckySix',
  'LuckyX',
  'GreyhoundRaces',
  'VirtualGreyhoundRaces',
  'HorseRaces',
  'VirtualHorseRaces',
  'VirtualMotorcycleSpeedway',
  'Keno',
  'VirtualPenaltyShootout',
  'NVNVLightningLuckySix',
  'CrashCash',
  'VirtualSoccer',
];

const isNgsGame = (productDisplayId: string) => ngsProducts.includes(productDisplayId);

/**
 * Ignore CrashCash (not integrated on Superbet,
 * lacks betshop UUID, blocks payout/cancel on terminal channel)
 */
const isNgsWebTicket = (
  productDisplayId: string,
  betshopUuid: string | undefined | null,
) => isNgsGame(productDisplayId) && !betshopUuid && !['CrashCash'].includes(productDisplayId);

export {
  isNgsWebTicket,
  isNgsGame,
};
